"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

/* eslint-disable */
var _default = /*#__PURE__*/React.createElement("svg", {
  width: "14",
  height: "14",
  viewBox: "1 2 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    display: 'inline-block',
    width: '1em',
    height: '1em',
    verticalAlign: 'middle',
    userSelect: 'none'
  }
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "svg_4",
  fill: "black",
  d: "m13.3636,1.26704l-12.72728,0c-0.35119,0 -0.63632,-0.28501 -0.63632,-0.63633c0,-0.35131 0.28513,-0.63632 0.63633,-0.63632l12.72727,0c0.3513,0 0.6364,0.28501 0.6364,0.63632c0,0.35132 -0.2851,0.63633 -0.6364,0.63633z"
}), /*#__PURE__*/React.createElement("path", {
  id: "svg_6",
  fill: "black",
  d: "m13.3636,7.63073l-12.72728,0c-0.35119,0 -0.63632,-0.2851 -0.63632,-0.6364c0,-0.35122 0.28513,-0.63634 0.63633,-0.63634l12.72727,0c0.3513,0 0.6364,0.28512 0.6364,0.63634c0,0.3513 -0.2851,0.6364 -0.6364,0.6364z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "null",
  id: "svg_8",
  fill: "black",
  d: "m11.0068,4.25565l-7.38738,0c-0.2912,0 -0.52763,-0.28513 -0.52763,-0.63632c0,-0.35132 0.23643,-0.63644 0.52764,-0.63644l7.38737,0c0.29131,0 0.52766,0.28512 0.52766,0.63644c0,0.35119 -0.23634,0.63632 -0.52766,0.63632z"
}), /*#__PURE__*/React.createElement("path", {
  id: "svg_9",
  fill: "black",
  d: "m13.3636,14.00753l-12.72728,0c-0.35119,0 -0.63632,-0.2851 -0.63632,-0.6364c0,-0.35122 0.28513,-0.63634 0.63633,-0.63634l12.72727,0c0.3513,0 0.6364,0.28512 0.6364,0.63634c0,0.3513 -0.2851,0.6364 -0.6364,0.6364z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "null",
  id: "svg_10",
  fill: "black",
  d: "m11.0068,10.82569l-7.38738,0c-0.29121,0 -0.52763,-0.28513 -0.52763,-0.63632c0,-0.35132 0.23642,-0.63644 0.52764,-0.63644l7.38737,0c0.29131,0 0.52766,0.28512 0.52766,0.63644c0,0.35119 -0.23635,0.63632 -0.52766,0.63632z"
})));

exports["default"] = _default;
//# sourceMappingURL=alignCenter.js.map